<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <div class="grid-container">
        <div class="item1 text-uppercase">
          <h6>{{ $t("kids.kids") }}</h6>
        </div>
        <div class="item2">
          <span class="text-uppercase">{{ $t("kids.name") }}</span
          ><span>: {{ kid.kid_name }}</span>
        </div>
        <div class="item3">
          <span class="text-uppercase">{{ $t("parents.parent") }}</span
          ><span>: {{ kid.parent_object.parent_name }}</span>
        </div>
        <div class="item4">
          <img :src="kid.image" class="right-img" />
          <soft-badge
            color="warning"
            variant="gradient"
            size="sm"
            @click="$emit('close')"
            class="cursor-pointer close"
          >
            {{ $t("global.close") }}
          </soft-badge>
        </div>
      </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center justify-content-center mb-0">
          <thead>
            <tr>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 subcourse-title"
              >
                {{ $t("kids.name") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                {{ $t("kids.subscribedSubcourse") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                {{ $t("teachers.detail.subcourseStartDate") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                {{ $t("kids.numberOfPayments") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder text-center opacity-7 ps-2"
              >
                {{ $t("kids.unpaidInstallments") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                {{ $t("teachers.pastMonths") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                {{ $t("subcourses.discount") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder text-center opacity-7 ps-2"
              >
                {{ $t("teachers.detail.subcourseDuration") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <td class="subcourse-title">
              {{ localKid.kid_name }}
            </td>
            <td>
              <p
                v-for="subcourse in localKid.subcourse"
                :key="subcourse.id"
                class="text-xs font-weight-bold"
              >
                {{ subcourse.title }}
              </p>
            </td>
            <td>
              <p
                v-for="subcourse in localKid.subcourse"
                :key="subcourse.id"
                class="text-xs font-weight-bold"
              >
                {{ subcourse.start_date }}
              </p>
            </td>
            <td>
              <p
                v-for="subcourse in localKid.subcourse"
                :key="subcourse.id"
                class="text-xs font-weight-bold"
              >
                <span
                  :class="
                    getInstallmentStyle(
                      subcourse.number_of_finished_months,
                      subcourse.paid_installment
                    )
                  "
                >
                  {{ subcourse.paid_installment }}
                </span>
              </p>
            </td>
            <td>
              <div
                v-for="subcourse in localKid.subcourse"
                :key="subcourse.id"
                class="text-xs font-weight-bold"
              >
                <div class="checkbox-group">
                  <div
                    v-for="item in Number(subcourse.number_of_months)"
                    :key="item"
                    class="d-flex mx-1 align-items-center justify-content-center"
                  >
                    <div
                      v-if="
                        isItemLessOrEqualThanPaidInstallment(
                          item,
                          subcourse.paid_installment
                        )
                      "
                    >
                      <input
                        class="form-check-input"
                        style="margin-top: -4px"
                        type="checkbox"
                        checked
                        :disabled="true"
                      />
                      {{ item }}.
                    </div>
                    <div v-else>
                      <SoftCheckbox
                        id="checkbox"
                        :disabled="!lastSeason"
                        :checked="false"
                        @change="
                          executePayment(item, localKid.id, subcourse.id)
                        "
                      >
                        <div class="unchecked-box">{{ item }}.</div>
                      </SoftCheckbox>
                    </div>
                  </div>
                </div>
              </div>
            </td>
            <td>
              <p
                v-for="subcourse in localKid.subcourse"
                :key="subcourse.id"
                class="text-xs font-weight-bold"
              >
                {{ subcourse.number_of_finished_months }}.
              </p>
            </td>
            <td class="align-middle ps-2">
              <p
                v-for="subcourse in localKid.subcourse"
                :key="subcourse.id"
                class="text-xs font-weight-bold"
              >
                {{ formatPrice(subcourse.discount) }}
                {{ $t("global.currency") }}
              </p>
            </td>
            <!-- <td class="align-middle text-center">
                  <div class="d-flex align-items-center justify-content-center">
                    <span class="me-2 text-xs font-weight-bold"
                      >{{ kid.course_progress }}%</span
                    >
                    <div>
                      <soft-progress
                        color="info"
                        variant="gradient"
                        :percentage="kid.course_progress"
                      />
                    </div>
                  </div>
                </td> -->
            <td class="align-middle ps-2">
              <p
                v-for="subcourse in localKid.subcourse"
                :key="subcourse.id"
                class="text-xs font-weight-bold"
              >
                {{ subcourse.number_of_months }}
                {{ this.formatMonthsTitle(subcourse.number_of_months) }}
              </p>
            </td>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
//import SoftProgress from "@/components/SoftProgress";
import axios from "axios";
import swal from "sweetalert2";
import SoftBadge from "@/components/SoftBadge.vue";
import SoftCheckbox from "@/components/SoftCheckbox.vue";

export default {
  name: "kid-details",
  components: {
    //SoftProgress,
    SoftBadge,
    SoftCheckbox,
  },
  props: {
    kid: {
      type: Object,
      required: true,
      default: () => {},
    },
    lastSeason: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      value: 0,
      checkedOptions: [],
      localKid: { ...this.kid },
    };
  },
  methods: {
    async executePayment(item, kid_id, subcourse_id) {
      const result = await swal.fire({
        title: this.$t("global.areYouSure"),
        text: this.$t("payments.notAllowedReverse"),
        icon: "question",
        showCancelButton: true,
        cancelButtonText: this.$t("global.no"),
        cancelButtonColor: "#f54539",
        confirmButtonText: this.$t("global.yes"),
        confirmButtonColor: "#82d616",
      });
      if (result.isConfirmed) {
        try {
          const response = await axios.post("execute-payment", {
            installment: item,
            kidId: kid_id,
            subcourseId: subcourse_id,
          });
          this.localKid = response.data.kid;

          swal.fire({
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 2000,
          });
        } catch (error) {
          console.log(error);
        }
      } else {
        swal.fire({
          title: "Evidencija uplate otkazana!",
          text: "",
          icon: "success",
        });
      }
    },
    formatPrice(value) {
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2, // Obavezna dva decimalna mesta
        maximumFractionDigits: 2, // Maksimalna dva decimalna mesta
      }).format(value);
    },
    formatMonthsTitle(numberOfMonths) {
      return numberOfMonths > 4
        ? this.$t("teachers.detail.months")
        : this.$t("teachers.detail.month");
    },
    getInstallmentStyle(number_of_finished_months, paid_installment) {
      return number_of_finished_months > paid_installment
        ? "p-1 mb-0 btn btn-icon-only btn-rounded me-0 btn-sm align-items-center justify-content-center btn-danger mt-1"
        : "align-items-center justify-content-center p-1 mb-0 mt-0";
    },
    isItemLessOrEqualThanPaidInstallment(item, piadInstallment) {
      return item <= piadInstallment ? true : false;
    },
  },
  watch: {
    kid(newKid) {
      this.localKid = { ...newKid };
    },
  },
};
</script>

<style scoped>
.container {
  display: inline-flex;
  justify-content: flex-start;
  position: relative;
}
tr,
td {
  text-align: center;
  vertical-align: middle;
}
.subcourse-title {
  padding-left: 30px;
  text-align: left;
}
.checkbox-group {
  display: flex;
  gap: 10px;
}
.checkbox-group label {
  display: inline-block;
}
.unchecked-box {
  margin-left: -6px;
  margin-top: 6px;
}
.item1 {
  grid-area: teacher-detail;
  height: 1px;
}
.item2 {
  grid-area: teachers-name;
  height: 3px;
  font-size: medium !important;
}
.item3 {
  grid-area: teachers-course;
  height: 3px;
  font-size: medium !important;
}
.item4 {
  grid-area: teachers-image;
}
.close {
  position: relative;
  float: right !important;
}
.grid-container {
  display: grid;
  grid-template-areas:
    "teacher-detail teacher-detail teacher-detail teacher-detail teachers-image teachers-image"
    "teachers-name teachers-name teachers-name teachers-name teachers-image teachers-image"
    "teachers-course teachers-course teachers-course teachers-course teachers-image teachers-image";
  gap: 1px;
  padding: 1px;
}
.grid-container > div {
  background-color: rgba(255, 255, 255, 0.8);
  text-align: left;
  padding: 5px 20px;
  font-size: 20px;
}
.right-img {
  position: relative;
  border: 1px solid gray;
  padding: 6px;
  border-radius: 8px;
  width: 120px !important;
  height: 120px !important;
  margin-left: 50%;
}
</style>
